'use strict';

// The premiere: 1 November 2026, 13:00 in Poland (winter time, UTC+1).
// Season 1 is created ahead with this start, so the server turns players away
// before it and the browser counts down to the same moment. Administrators
// play earlier, unannounced, to check the live game.
const LAUNCH_AT = Date.parse('2026-11-01T12:00:00Z');

// A season is open for commands while it runs; before its start only for an
// administrator, and then nothing about the run is announced to anyone.
const seasonOpen = (season, ms, { early = false } = {}) => !!season && season.status === 'active'
  && (ms >= season.startsAt || early) && ms < season.endsAt;

module.exports = { LAUNCH_AT, seasonOpen };
